<template>
    <v-container fluid class="pa-3 black">
        <v-card elevation="12" class="ma-2 pa-2 primary">
        <v-row class="justify-center align-center ma-3 pa-3"><h1 class="font-weight-black textTitle--text">{{ $t('modifproduct.screenTitle') }}</h1></v-row>
        <v-row class="justify-center "><v-chip color="textTitle" label outlined><h2>{{ $t('modifproduct.product') }}</h2><h2 class="mx-2">{{tempProd.id}}</h2></v-chip>
                </v-row>
                <v-text-field :label="$t('addproduct.prodName')" v-model="tempProd.name" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         <v-text-field :label="$t('addproduct.prodCode')" v-model="tempProd.codigo" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         <v-text-field :label="$t('addproduct.prodDesc')" v-model="tempProd.desc" background-color="quinty" height="60px" color="primary"  rounded class="font-weight-black text-h6 ma-2 pa-2 shrink"></v-text-field>
         <v-text-field :label="$t('addproduct.invInit')" type="number" v-model.number="tempProd.initInv" background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         
         <v-card class="ma-3 pa-3 primary" flat>
           <h2 class="d-flex justify-center font-weight-black textTitle--text">{{ $t('addproduct.prodPuBuy') }}</h2>
            <v-row class="justify-center align-center"> 
         <v-col cols="5">
           <v-text-field  type="number" v-model.number="tempProd.pu_buy" min="0" prefix="Q." background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         
       </v-col>
         <v-col cols="5">
           <v-select v-model="tempProd.vendedor" :items="fournisseursDb" :item-text="'name'" :label="$t('addproduct.supplier')" background-color="quinty" class="primary--text mx-5 pa-3 font-weight-black" solo >
                <template v-slot:append-outer>
                  <v-btn small rounded class="info" @click="manageFournisseurDialog=!manageFournisseurDialog">!</v-btn>
                  <v-dialog v-model="manageFournisseurDialog" width="80%" :retain-focus="false">
                      <manageFournisseur :key="buyForm" />
                    </v-dialog>   
                </template>
                                </v-select>
         </v-col> 
         </v-row> 

         <addPrecioCompraMayor :precioscomprasmayor="tempProd.price_mayor_buy" @update="updatepreciospormayorbuy"/>
         </v-card>

         <v-card class="ma-3 pa-3 primary" flat>
           <h2 class="d-flex justify-center font-weight-black textTitle--text">{{ $t('addproduct.prodPuSell') }}</h2>
            <v-row class="justify-center align-center"> 
         
           <v-text-field  type="number" v-model.number="tempProd.pu_sell" min="0" prefix="Q." background-color="quinty" color="primary"  rounded height="60px" class="font-weight-black text-h4 ma-2 pa-2 shrink"></v-text-field>
         
       
         </v-row> 

         <addPrecioVentaMayor :preciosventasmayor="tempProd.price_mayor_sell" @update="updatepreciospormayorsell"/>
         </v-card>
               
     <v-card elevation="5" class="ma-5 pa-5 secondary">
       <v-card class="primary" elevation="11">
                <v-row class="justify-center ma-3 pa-3 font-weight-black"> <h2 class="tertiary--text">{{ $t('modifproduct.currentCat') }}<v-chip color="textMenu text-h5 font-weight-black" label>{{tempProd.catname}}</v-chip>{{ $t('addproduct.prodCode') }}<v-chip color="textMenu text-h6 font-weight-black" label>{{tempProd.catid}}</v-chip>)</h2> </v-row>
                <v-card-title class="d-flex justify-center textTitle--text font-weight-black text-h3">{{ $t('modifproduct.catAvail') }}</v-card-title>
                    <v-row class="justify-center ma-2 pa-2">
              <v-btn class="ma-2 pa-2 font-weight-black black--text" small color="quinty" elevation="24" @click="manageCat">{{ $t('addproduct.catFormTitle') }}</v-btn>
            </v-row>
                    
                    <v-treeview
                    :items="treeviewCatItems"
                    activatable
                    :multiple-active="false" 
                    :active.sync="catactive" 
                    return-object
                    open-all
                    class="quaterny ma-3 pa-3 font-weight-black textTable--text"
                    expand-icon="mdi-plus secondary quinty--text ma-3 pa-3"
                    active-class="textMenu font-weight-black black--text"
                    hoverable
                ></v-treeview>
                <v-dialog v-model="manageCatDialog" width="80%" :retain-focus="false">
                 <catManager :key="catform" />
               </v-dialog>  
                <v-row class="justify-space-between" v-if="catactive[0]">
                <v-col cols="5.5">
                  <v-row class="ma-2 pa-2 justify-center">
                  <h2 class="mr-3 tertiary--text">{{ $t('modifproduct.newCat') }}</h2>
                  <v-chip  color="textMenu text-h5 font-weight-black" label ><h2 class="ma-2">{{catactive[0].name}}</h2></v-chip>
                  </v-row>
                  <v-row class="ma-2 pa-2 justify-center">
                    <h2 class="mr-3 tertiary--text">{{ $t('modifproduct.newCode') }}</h2>
                    <v-chip color="textMenu text-h5 font-weight-black" label ><h2 class="ma-2">{{catactive[0].id}}</h2></v-chip>
                  </v-row>
                </v-col>
                </v-row>
                </v-card>
     </v-card>
                
                 <v-card elevation="11" class="ma-5 pa-5 secondary">
                   <v-card-title class="d-flex justify-center textTitle--text font-weight-black text-h3">{{ $t('modifproduct.proriedades') }}</v-card-title> 
                   <v-row class="justify-center align-center">
                  <v-col cols="6">
                    <v-card elevation="8" class="ma-2 pa-5 primary" width="90%">
                        <v-row class="justify-center align-center"><h3 class="textTitle--text font-weight-black">{{ $t('addproduct.prodProps') }}</h3></v-row>
                    
                    <v-row class="justify-center align-center">
                      
                    <v-chip-group
                      column
                      class="quaterny ma-3 pa-3"
                      v-model="propactiveprod"
                      return-object
                      mandatory
                    >
                      <v-chip
                        v-for="prop in prodProps"
                        :key="prop.id"  
                        :value="prop"   
                        class="primary textMenu--text pa-3 font-weight-black"           
                      >
                        {{ prop.name }}
                      </v-chip>
                    </v-chip-group>
                    
                    </v-row>
                    <v-row class="justify-center align-center">
                    <v-btn class="ma-1 pa-2 font-weight-black black--text" color="error" small elevation="3" solo @click="removePropFromProd">{{ $t('addproduct.removeProp') }}</v-btn>
                    </v-row>
                    </v-card>
                    
                  </v-col>
                    <v-col cols="6">
                    <v-card elevation="8" class="ma-5 pa-5 primary">
                        <v-row class="justify-center align-center"><h3 class="textTitle--text font-weight-black">{{ $t('addproduct.propsDispo') }}</h3></v-row>
                    <v-row class="justify-center align-center">
                      
                    <v-chip-group
                      column
                      multiple
                      class="quaterny pa-3 ma-3"
                      v-model="selectedpropsdb"
                      return-object
                      mandatory
                      rounded
                    >
                      <v-chip
                        v-for="prop in propsdb"
                        :key="prop.id"  
                        :value="prop"    
                        class="primary textMenu--text pa-3 font-weight-black"           
                      >
                        {{ prop.name }}
                      </v-chip>
                    </v-chip-group>

                    
                    </v-row>
                    <v-row class="justify-center align-center">
                                  <v-btn class="ma-1 pa-2 font-weight-black black--text" color="success" elevation="3" small solo @click="addPropToProd">{{ $t('addproduct.addProp') }}</v-btn>
                      <v-btn class="ma-1 font-weight-black black--text" color="info" elevation="3" small solo @click="manageProp">{{ $t('addproduct.configProp') }}</v-btn>        
                    </v-row>
                    </v-card>
                    <v-dialog v-model="managePropDialog" width="80%" :retain-focus="false">
                      <propManager :key="propform" />
                    </v-dialog>
                  </v-col>
                </v-row>

                <v-row class="justify-center align-center ma-3 pa-3">
             <v-col cols="10">
           <v-card elevation="5" solo class="ma-2 pa-2 primary">
             <v-card-title class="justify-center font-weight-black textTitle--text text-h4">{{ $t('addproduct.propValues') }}</v-card-title>
            <div v-for="propis in prodProps" :key="propis.id">
              <v-row v-if="propis.typeform==$t('propmanager.selectOption2')" class="pa-4 mx-3 align-center justify-center">
                
                <h2 class="font-weight-black textTitle--text text-decoration-underline">{{propis.name}} : </h2>
                <v-text-field type="number" v-model.number="propis.value" background-color="quinty"  class="ml-3 pa-1 font-weight-black primary--text shrink text-h6" outlined solo></v-text-field>            
              
              </v-row>
              <v-row v-if="propis.typeform==$t('propmanager.selectOption1')" class="pa-4 mx-3 align-center justify-center">
                
                <h2 class="font-weight-black textTitle--text text-decoration-underline">{{propis.name}} : </h2>
                <v-text-field type="text" v-model="propis.value"  background-color="quinty"  class="ml-3 pa-1 font-weight-black primary--text shrink text-h6" solo outlined></v-text-field>            
              
              </v-row>
              <v-row v-if="propis.typeform==$t('propmanager.selectOption3')" class="pa-4 mx-3 align-center justify-center">
                
                <h2 class="font-weight-black textTitle--text text-decoration-underline">{{propis.name}} : </h2>
                <v-select
                v-if="propis.typeform=='select'"
                v-model="propis.value" 
                background-color="quinty"  
                class="ma-1 pa-1 font-weight-black primary--text shrink text-h6"
                :items="propis.selectoptions"
                outlined
              ></v-select> 
              </v-row>
                   
            </div>   
         </v-card>
         </v-col>
           </v-row>


                
              <v-row class="justify-center align-center">
              <v-btn @click="confirmModif" x-large elevation="24" class="success ma-5 pa-5 font-weight-black black--text text-h5">{{ $t('modifproduct.confirmarModificaciones') }}</v-btn>
              </v-row>
                 </v-card>

                
       
        </v-card>
    </v-container>
</template>

<script>
import propManager from "@/components/propManager"
import catManager from "@/components/catManager"
import manageFournisseur from "@/components/manageFournisseur"
import addPrecioCompraMayor from '@/components/addPrecioCompraMayor.vue'
import addPrecioVentaMayor from '@/components/addPrecioVentaMayor.vue'

import {mapGetters} from 'vuex'

export default {
    props:['prod'],
    components:{addPrecioCompraMayor,addPrecioVentaMayor,propManager,catManager,manageFournisseur},
    data () {
        return {
            catactive:[],
            propactiveprod:{},
            selectedpropsdb:[],
            prodProps:[],
            fournisseurPu:'',
            fournisseur:'',
            
            manageFournisseurDialog:false,
            buyForm:0,
            managePropDialog:false,
            propform:0,
            manageCatDialog:false,
            catform:0,
            tempProd:{},
            
        }},
        computed:{
           ...mapGetters({
                categories:'catdb',
                propsdb:'propsDb',
                fournisseursDb:'fournDb',
                treeviewCatItems:'treeviewCatDb'
              })
        },
    mounted() {
          this.copyProd();
          this.getProdProps();         
        },
        methods:{
          copyProd(){
            this.tempProd=JSON.parse(JSON.stringify(this.prod))
          },
        manageProp(){
        this.propform+=1
        this.managePropDialog=true
      },
      manageCat(){
        this.catform+=1
        this.manageCatDialog=true
      },
        updatepreciospormayorbuy(v){

        this.tempProd.price_mayor_buy=v
        //console.log(v)
      },
      updatepreciospormayorsell(v){

        this.tempProd.price_mayor_sell=v
        //console.log(v)
      },
        removePropFromProd(){
          var name = this.propactiveprod.name;
          this.temparray=[];
          if(name!=null){
            var size = this.prodProps.length; 
            for(var i=0;i<size;i++){
              if(this.prodProps[i].name!=name){
                    this.temparray.push(this.prodProps[i])
              }                  
            }
            this.prodProps=this.temparray;
            
          }
        },
        manageFournisseur(){
          this.buyForm+=1;
          this.manageFournisseurDialog=true;
        },
        addPropToProd(){
          this.temparray=[];
          var size = this.selectedpropsdb.length; 
          var sizeprodprop = this.prodProps.length; 
          var has=0;
          if(size!=null){
            this.temparray=this.prodProps;
            for(var i=0;i<size;i++){
              has=0;
              for(var u=0;u<sizeprodprop;u++){
                if(this.selectedpropsdb[i].name==this.prodProps[u].name){has=1}
                   
              }
              if(has==0){ this.temparray.push(this.selectedpropsdb[i])}
            }
            this.prodProps=this.temparray;
          }
        },
        getProdProps(){
          var keys = Object.keys(this.tempProd)
          var size = keys.length;
          const prodheaders = ["id","name","desc","pu_sell","pu_buy","price_mayor_sell","price_mayor_buy","catid", "codigo","catname","vendedor","currenttInv","initInv","requestInv","invAlert"]
          var prodProps = [];
          for(var i=0;i<size;i++){
            if(!prodheaders.includes(keys[i])){
              var type = this.propsdb.find(elem => elem.name ===keys[i])
              
              prodProps.push({name:keys[i],value:this.tempProd[keys[i]],typeform:type.typeform,selectoptions:type.selectoptions})
              }
          }
          this.prodProps=prodProps
        },
        confirmModif(){
          var name=this.tempProd.name;
          var desc=this.tempProd.desc;
          var id = this.tempProd.id;
          var props = []
          
              var size=this.prodProps.length;
                for(var i=0;i<size;i++){
                  props.push(JSON.parse(JSON.stringify(this.prodProps[i])))
                }
                
              var pusell = this.tempProd.pu_sell;
              var pumayorsell = this.tempProd.price_mayor_sell;
              var pumayorbuy = this.tempProd.price_mayor_buy;
              var pubuy = this.tempProd.pu_buy;
              var catid = '';
              var catname = '';
              if(this.catactive[0]){    
                //console.log(this.catactive[0])
                catid = this.catactive[0].id
                catname = this.catactive[0].name
                if(catid!=this.tempProd.catid){
                  var payload = {"id":this.tempProd.catid,"ammount":-1}
                  this.$store.dispatch('modifProductCatQty',payload)

                  payload = {"id":catid,"ammount":1}
                  this.$store.dispatch('modifProductCatQty',payload)

                }}
              else{
                 catid = this.tempProd.catid
                 catname = this.tempProd.catname
              }
              var codigo = this.tempProd.codigo
              var initInv = this.tempProd.initInv

              
              
              var product={
                'id':id,
                'codigo':codigo,
                'name':name,
                'vendedor':this.fournisseurPu,
                'desc':desc,
                'pu_buy':pubuy,
                'pu_sell':pusell,
                'price_mayor_sell':pumayorsell,
                'price_mayor_buy':pumayorbuy,
                'initInv':initInv,
                'currenttInv':this.tempProd.currenttInv,
                'requestInv':this.requestInv,
                'invAlert':this.catactive[0].invAlert,
                'catid':catid,
                'catname':catname,
              }
              for(var y=0;y<props.length;y++){
                product[props[y].name]=props[y].value;
              }

              payload={"id":id,"prod":product}

              this.$store.dispatch('modifProduct',payload)
              //this.clearform();
              this.$emit('dialogend', false);     
        }
      
        }
}
</script>